/**
 * Note generation error helpers.
 */

import { NOTE_GENERATION_ERROR_PRESETS } from './presets';
import type {
  NoteGenerationErrorContent,
  NoteGenerationErrorProps,
} from './types';

/**
 * Resolves preset or custom props to a single content shape. Use this when you need
 * the error message content without rendering (e.g. for titles or other UI).
 */
export function getNoteGenerationErrorContent(
  props: NoteGenerationErrorProps,
): NoteGenerationErrorContent {
  if (!('preset' in props)) {
    return {
      kind: 'simple',
      title: props.title,
      description: props.description,
    };
  }
  const content = NOTE_GENERATION_ERROR_PRESETS[props.preset];
  return {
    kind: 'structured',
    title: content.title,
    intro: content.intro,
    listItems: content.listItems,
    tryThis: content.tryThis,
  };
}
